<template>
  <v-card>
    <v-card-text>
      <v-row>
      
          <v-col v-for="(field,index) in fields" :key="`fields-${index}-${field.title}`" cols="4">
            <component
              :is="field.component"
              v-model="tile[field.model]"
              :title="field.title"
              :label="field.title"
              :prefix="field.prefix"
              :color="field.color"
              class=""
            />
          </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src
import { UnitTextArea, UnitTextField, UnitTag } from "@/components/units";

export default {
  name: "AdminTileUpload",
  components: { UnitTextArea, UnitTextField, UnitTag },
  data() {
    return {
      isValid: true,
       fields: [
        {
          title: "Title",
          count: 1,
          component: UnitTextArea,
          model: "title",
          color: "red"
        },
        {
          title: "Flag",
          count: 2,
          component: UnitTextArea,
          model: "flag",
          color: "red"
        },
        {
          title: "Strapline",
          count: 3,
          component: UnitTextArea,
          model: "concept",
          color: "red"
        },
        {
          title: "Description",
          count: 4,
          component: UnitTextArea,
          model: "description",
          color: "red"
        },
        {
          title: "Promise",
          count: 5,
          component: UnitTextArea,
          model: "promise",
          color: "red"
        },
        {
          title: "Justification",
          count: 6,
          component: UnitTag,
          model: "justification",
          color: 'amber'
        },
        {
          title: "Pillars",
          count: 7,
          component: UnitTag,
          model: "pillars",
          color: 'amber'
        }
       ]
    };
  },
  props: {
    tile: Object,
  },
  methods: {
    getSrc(val) {
      this.tile.src = val;
    },
    getName(val) {
      this.tile.title = val;
      this.$nextTick(() => {
        this.tile.title = val;
      });
    },
    validateImage(val) {
      this.isValidImage = val;
    },
  },
};
</script>
